<!-- 打包销售订单的数据 -->
<template>
    <div v-loading="loading">
        <div class="table-ctn" style="margin-top:10px">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%; margin-bottom: 0px">
                <el-table-column prop="OrderCode" label="订单号" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="GoodsCount" label="商品数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="OrderAmount" label="订单总额"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="送达时间"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[15, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['SId', 'StartDate', 'EndDate'],
    components: {},
    data() {
        return {
            loading: false,
            searchData: {
                SId: '',
                page: 1,
                limit: 15,
                StartDate: '',
                EndDate: ''
            },
            tableData: [],
            tableDataLength: 0
        };
    },
    mounted() {
        this.searchData.SId = this.SId;
        this.searchData.StartDate = this.StartDate;
        this.searchData.EndDate = this.EndDate;
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/DataStatistics/GetDeliverSaleOrder',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;

                    if (this.searchData.page == 1) {
                        this.tableDataLength = res.count;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    flex-direction: row-reverse;
}
.data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 12.5%;
    border-left: 1px solid @border4Color;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
        margin-bottom: 5px;
    }
}
.search-ctn {
    .search-ctn-left {
        margin-top: 5px;
        .search-name,
        .search-item,
        button {
            margin-bottom: 10px;
        }
    }
    .search-btn,
    .search-item {
        margin-bottom: 0;
    }
}
</style>
